<template>
  <div class="Index">
    <div class="libe_home_nav" v-if="scroll >= 88">
      <headNav :activeNav="'Inicio'"></headNav>
    </div>
    <div class="libe_home_wrap">
      <div class="libe_homenav" v-if="scroll < 88">
        <homeNav :activeNav="'Inicio'" v-if="scroll < 88"></homeNav>
      </div>
      <div class="libe_home_banner">
        <div class="libe_home_banner_img">
          <img src="../assets/img/arrecredi_banner_1.webp" alt="">
        </div>
      </div>

      <div class="arrecredi_btoptext">
        <div class="arrecredi_btoptext_img">
          <img src="../assets/img/arrecredi_btoptext_img.webp" alt="">
        </div>
      </div>
      <div class="arrecredi_bcenttext">
        <div class="arrecredi_bcenttext_desc">
          Recibe dinero al instante con límites que crecen rápido – ¡solución confiable para sus emergencias!
        </div>
      </div>
      <div class="eshoy_home_google_link" @click.stop="openGooglePlayLink">
        <div class="google_link_wrap">
          <img src="../assets/img/google_link_1.webp" alt="">
        </div>
      </div>
      <div class="arrecredi_bdondv">
        <div class="arrecredi_bdon_list">
          <div class="arrecredi_bdon_view">
            <div class="arrecredi_bdon_one">
              <img src="../assets/img/arrecredi_bdon_1.webp" alt="">
            </div>
            <div class="arrecredi_bdon_two">
              <img src="../assets/img/arrecredi_bdon_2.webp" alt="">
            </div>
            <div class="arrecredi_bdon_thr">
              <img src="../assets/img/arrecredi_bdon_3.webp" alt="">
            </div>
            <div class="arrecredi_bdon_fur">
              <img src="../assets/img/arrecredi_bdon_4_1.webp" alt="">
            </div>
          </div>
        </div>
      </div>

      <div class="arrecredihome1v">
        <div class="arrecredihome1v_title">
            <span>¿Por qué elegir Arrecredi?</span>
        </div>
        <div class="arrecredihome1v_view">
          <div class="arrecredihome1v_vtleft">
            <img src="../assets/img/arrecredihome1v_vtl.webp" alt="">
          </div>
          <div class="arrecredihome1v_vtright">
            <div class="arrecredihome1v_vtr">
              <div class="arrecredihome1v_vtrtitle">Límite de crédito crece RÁPIDO</div>
              <div class="arrecredihome1v_vtrtext">Tu línea de crédito aumenta a lo bestia con cada préstamo – la más rápida de MX.</div>
            </div>
          </div>
        </div>
        <div class="arrecredihome1v_view">
          <div class="arrecredihome1v_vdleft">
            <div class="arrecredihome1v_vdl">
              <div class="arrecredihome1v_vdltitle">Intereses que BAJAN con el tiempo</div>
              <div class="arrecredihome1v_vdltext">Mientras más pides, menos pagas: tasa diaria desde 0.003% (¡la más baja del mercado!).</div>
            </div>
          </div>
          <div class="arrecredihome1v_vdright">
            <img src="../assets/img/arrecredihome1v_vdr.webp" alt="">
          </div>
        </div>
      </div>

      <div class="arrecredihome2v">
        <div class="arrecredihome1v_title">
          <span>¡Arrecredi te garantiza!</span>
        </div>

        <div class="arrecredihome2v_carousel">
          <el-carousel indicator-position="none" arrow="never" @change="onCarouselChange" height="0px">
            <el-carousel-item v-for="item in 3" :key="item">
              <h3>{{ item }}</h3>
            </el-carousel-item>
          </el-carousel>
        </div>

        <div class="arrecredihome2v_dv">
            <div class="arrecredihome2v_1" :class="carouselIndex == 1 ? 'arrecredihome2v_740': 'arrecredihome2v_270'" @click.stop="onCarouselSetIndex(1)">
                <div class="arrecredihome2v_title">Crédito que crece contigo</div>
                <div class="arrecredihome2v_1_bg">
                  <img src="../assets/img/arrecredihome2v_1_b.webp" alt="">
                </div>
                <div class="arrecredihome2v_1_text">
                  Más préstamos = mayor límite + más plazo + tasas con descuento
                </div>
                <div class="arrecredihome2v_1_card">
                  <img src="../assets/img/arrecredihome2v_1n.webp" alt="">
                </div>
            </div>
            <div class="arrecredihome2v_2" :class="carouselIndex == 2 ? 'arrecredihome2v_740': 'arrecredihome2v_270'" @click.stop="onCarouselSetIndex(2)">
                <div class="arrecredihome2v_title">Promos cada mes (2+ veces)</div>
                <div class="arrecredihome2v_2_bg">
                  <img src="../assets/img/arrecredihome2v_2_b.webp" alt="">
                </div>
                <div class="arrecredihome2v_2_text">
                  Clientes fieles y nuevos: ¡siempre hay ofertas chidas para ti!
                </div>
                <div class="arrecredihome2v_2_card">
                  <img src="../assets/img/arrecredihome2v_2.webp" alt="">
                </div>
            </div>
            <div class="arrecredihome2v_3" :class="carouselIndex == 3 ? 'arrecredihome2v_740': 'arrecredihome2v_270'" @click.stop="onCarouselSetIndex(3)">
                <div class="arrecredihome2v_title">Seguridad al 100%</div>
                <div class="arrecredihome2v_3_bg">
                  <img src="../assets/img/arrecredihome2v_3_b.webp" alt="">
                </div>
                <div class="arrecredihome2v_3_text">
                  Tus datos en servidores privados – cero fuga, cero riesgo.
                </div>
                <div class="arrecredihome2v_3_card">
                  <img src="../assets/img/arrecredihome2v_3.webp" alt="">
                </div>
            </div>
        </div>
      </div>

      <div class="arrecredihome3v">
        <div class="arrecredihome3v_title">
          <span>Instala la aplicación Arrecredi</span>
          <p>Puedes descargar Arrecredi en Google Play.</p>
        </div>

        <div class="arrecredihome3v_dv">
          <div class="arrecredihome3v_dv_left">
            <div class="arrecredihome3v_dv_carousel">
              <el-carousel arrow="never" height="554px" ref="carouse" :interval="2000" @change="onCarouselActive">
                <el-carousel-item v-for="item in 3" :key="item">
                  <div class="arrecredihome3v_carousel">
                    <div class="arrecredihome3v_carousel_no">{{ carouselActive }}.</div>
                    <div class="arrecredihome3v_carousel_label">
                      <template v-if="carouselActive == 1">
                        Necesitas tener a la mano
                      </template>
                      <template v-else-if="carouselActive == 2">
                        Solicita un préstamo
                      </template>
                      <template v-else-if="carouselActive == 3">
                        Recibe tu dinero
                      </template>
                    </div>
                    <div class="arrecredihome3v_carousel_text">
                      <template v-if="carouselActive == 1">
                        <p>· INE</p>
                        <p>· CURP para mexicanos</p>
                        <p>· Número de teléfono</p>
                      </template>
                      <template v-else-if="carouselActive == 2">
                        <p>Ingresa la cantidad que necesitas y elige un método de pago que te convenga. Los intereses y comisiones son transparentes, puedes revisarlos en la aplicación.</p>
                      </template>
                      <template v-else-if="carouselActive == 3">
                        <p>Una vez confirmado tu préstamo, recibirás tu dinero en cuestión de minutos.</p>
                      </template>
                    </div>
                  </div>
                </el-carousel-item>
              </el-carousel>
            </div>
            <div class="arrecredihome3v_dv_ldv">
              <div class="arrecredihome3v_dv_ldvprev" @click="onCarouselPrev">
                <img src="../assets/img/prev_2.webp" alt="">
              </div>
              <div class="arrecredihome3v_dv_ldvnext" @click="onCarouselNext">
                <img src="../assets/img/next_2.webp" alt="">
              </div>
            </div>
          </div>
          <div class="arrecredihome3v_dv_right">
              <div class="arrecredihome3v_dv_rmg">
                <template v-if="carouselActive == 1">
                  <img src="../assets/img/arrecredihome3v_dv_r1.webp" alt="">
                </template>
                <template v-else-if="carouselActive == 2">
                  <img src="../assets/img/arrecredihome3v_dv_r2.webp" alt="">
                </template>
                <template v-else>
                  <img src="../assets/img/arrecredihome3v_dv_r3.webp" alt="">
                </template>
              </div>
          </div>
        </div>
      </div>

      <div class="arrecredihome4v">
        <img src="../assets/img/arrecredihome4v_1.webp" alt="">
      </div>

      <div class="arrecredihome5v">
        <div class="arrecredihome5v_title">
          <span>Preguntas frecuentes</span>
          <p>Clarificando tus dudas con respuestas completas a las preguntas más comunes.</p>
        </div>
        <div class="arrecredihome5v_dv">
          <div class="arrecredihome5v_dv_left"></div>
          <div class="arrecredihome5v_dv_right">
            <div class="arrecredihome5v_dv_rv_hover" @click.stop="goAyuda(1)">
              <div class="arrecredihome5v_dv_rv">
                <div class="arrecredihome5v_dv_rv_text">Preguntas sobre solicitud del préstamo</div>
                <div class="arrecredihome5v_dv_rv_icon">
                  <img src="../assets/img/arrecredihome5v_dv_rv_1.webp" alt="">
                </div>
              </div>
            </div>
            <div class="arrecredihome5v_dv_rv_hover" @click.stop="goAyuda(2)">
              <div class="arrecredihome5v_dv_rv">
                <div class="arrecredihome5v_dv_rv_text">Preguntas sobre transferencia del préstamo</div>
                <div class="arrecredihome5v_dv_rv_icon">
                  <img src="../assets/img/arrecredihome5v_dv_rv_1.webp" alt="">
                </div>
              </div>
            </div>
            <div class="arrecredihome5v_dv_rv_hover" @click.stop="goAyuda(3)">
              <div class="arrecredihome5v_dv_rv" style="border: none;">
                <div class="arrecredihome5v_dv_rv_text">Preguntas sobre pagar el préstamo</div>
                <div class="arrecredihome5v_dv_rv_icon">
                  <img src="../assets/img/arrecredihome5v_dv_rv_1.webp" alt="">
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="arrecredihome5v_dd">
          <div class="arrecredihome5v_ddmg">
            <img src="../assets/img/arrecredihome5v_ddmg_1.webp" alt="">
          </div>
        </div>
      </div>

    </div>

    <footPage></footPage>
  </div>
</template>

<script>
import headNav from "@/components/headNav.vue";
import homeNav from "@/components/homeNav.vue";
import footPage from "@/components/foot.vue";

export default {
    name: 'Index',
    components: { headNav, homeNav, footPage },
    data () {
      return {
        isFalse: false,
        activeNav: "Inicio",
        scroll: 0,
        changeNum: 0,
        sliderValue: 20000,
        isActive: 91,
        carouselIndex: 1,
        carouselActive: 1,
      }
    },
    created() {
      let nav = localStorage.getItem('activeNav');
      if (nav) {
        this.activeNav = nav;
      } else {
        localStorage.setItem('activeNav', this.activeNav);
      }
    },
    mounted(){
      window.addEventListener('scroll',this.handleScroll)
    },
    methods: {
      goAyuda(type){
        this.$router.push({
          path: '/notice',
          query: {
            seek: type
          }
        })
      },
      onCarouselSetIndex(index){
        this.carouselIndex = index;
      },
      onCarouselPrev() {
        this.$refs.carouse.prev();
      },
      onCarouselNext() {
        this.$refs.carouse.next();
      },
      onCarouselActive(i) {
        this.carouselActive = i + 1;
      },
      onCarouselChange(item) {
        console.log(item)
        this.carouselIndex = item + 1;
      },
      openGooglePlayLink() {
        //console.log('googleplay')
        window.location.href = 'https://app.adjust.com/1o8iv5h7';
      },
      handleScroll(){
        //或者使用document.querySelector('.class或者#id').scrollTop
        this.scroll = document.documentElement.scrollTop||document.body.scrollTop
      },
      getDays(day) {
        this.isActive = day;
      },
      dealNumber(num) {
        if (num != 0 && num) {
          num = num + "";
          let splitList = num.split(".");
          //将整数部分拆解为单个数字的数组倒序，然后拼装为新的数组，每3位数字进行一次匹配
          let intStrList = splitList[0]
                  .split("")
                  .reverse()
                  .join("")
                  .match(/(\d{1,3})/g);
          //将匹配后的数组用，拼接，再拆解为单个数字的数组，反转为原先数组形式，拼接为完整数字
          let intStr = intStrList.join(",").split("").reverse().join("");
          return intStr;
        }
        return num;
      },
    },
    //销毁,否则跳到别的路由还是会出现
    destroyed() {
      window.removeEventListener('scroll', this.handleScroll)
    }
  }
</script>

<style>
  .libe_home_wrap{
    width: 100%;
    height: auto;
    position: relative;
  }
  .libe_home_nav{
    width: 100%;
    height: auto;
    position: fixed;
    left: 0;
    top: 0;
    z-index: 1010;
  }
  .libe_homenav{
    width: 100%;
    height: auto;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 8;
  }
  .libe_home_banner{
    width: 100%;
    height: 988px;
    position:relative;
    overflow:hidden;
    z-index: 2;
  }
  .libe_home_banner_img{
    width: 1920px;
    position:absolute;
    left:50%;
    margin-left:-960px;
  }
  .eshoy_home_google_link{
    max-width: 1200px;
    width: 100%;
    height: auto;
    margin: 0 auto;
    position: relative;
    box-sizing: border-box;
    padding: 0 16px;
  }
  .arrecredi_btoptext{
    max-width: 1200px;
    width: 100%;
    height: auto;
    margin: 0 auto;
    position: relative;
    box-sizing: border-box;
    padding: 0 16px;
  }
  .arrecredi_btoptext_img{
    width: 830px;
    height: 127px;
    position: absolute;
    left: 0;
    top: -731px;
    z-index: 6;
  }
  .arrecredi_btoptext_img img{
    display: block;
    width: 100%;
    height: 136px;
  }
  .arrecredi_bcenttext{
    max-width: 1200px;
    width: 100%;
    height: auto;
    margin: 0 auto;
    position: relative;
    box-sizing: border-box;
    padding: 0 16px;
  }
  .arrecredi_bcenttext_desc{
    width: 639px;
    height: 60px;
    position: absolute;
    left: 0;
    top: -556px;
    z-index: 6;
    font-weight: 500;
    font-size: 20px;
    color: #FFFFFF;
    line-height: 30px;
    text-align: left;
    font-style: normal;
  }
  .arrecredi_bdondv{
    max-width: 1200px;
    width: 100%;
    height: auto;
    margin: 0 auto;
    position: relative;
    box-sizing: border-box;
    padding: 0 16px;
  }
  .arrecredi_bdon_list{
    width: 100%;
    height: 339px;
    position: absolute;
    left: -41px;
    top: -233px;
    z-index: 6;
  }
  .arrecredi_bdon_view{
    width: 100%;
    height: 339px;
    position: relative;
    cursor: pointer;
  }
  .arrecredi_bdon_one{
    width: 282px;
    height: 309px;
    position: absolute;
    left: 0;
    top: 0;
    transition: transform 0.3s ease;
  }
  .arrecredi_bdon_one:hover {
    transform: scale(1.2);
  }
  .arrecredi_bdon_two{
    width: 283px;
    height: 309px;
    position: absolute;
    left: 253px;
    top: 10px;
    transition: transform 0.3s ease;
  }
  .arrecredi_bdon_two:hover{
    transform: scale(1.2);
  }
  .arrecredi_bdon_thr{
    width: 282px;
    height: 309px;
    position: absolute;
    left: 506px;
    top: 20px;
    transition: transform 0.3s ease;
  }
  .arrecredi_bdon_thr:hover{
    transform: scale(1.2);
  }
  .arrecredi_bdon_fur{
    width: 282px;
    height: 307px;
    position: absolute;
    left: 759px;
    top: 32px;
    transition: transform 0.3s ease;
  }
  .arrecredi_bdon_fur:hover{
    transform: scale(1.2);
  }
  .Index {
    width: 100%;
    height: 100%;
    background-color: #fff;
    margin: 0;
    padding: 0;
  }
  .fotop_cont_dit_img img{
    display: block;
    width: 100%;
  }
  .google_link_wrap{
    width: 180px;
    height: 64px;
    position: absolute;
    left: 0px;
    top: -400px;
    z-index: 6;
  }
  .google_link_wrap img{
    display: block;
    width: 100%;
    cursor: pointer;
  }
  .arrecredihome1v{
    max-width: 1320px;
    width: 100%;
    height: auto;
    margin: 0 auto;
    box-sizing: border-box;
    padding: 245px 16px 0 16px;
  }
  .arrecredihome1v_title{
    width: 100%;
    height: 108px;
    display: flex;
    justify-content: center;
    align-items: flex-start;
  }
  .arrecredihome1v_title span{
    font-weight: bold;
    font-size: 48px;
    color: #262A48;
    text-align: left;
    font-style: normal;
  }
  .arrecredihome1v_view{
    width: 100%;
    height: 400px;
    display: flex;
    justify-content: space-between;
  }
  .arrecredihome1v_vtleft{
    width: 400px;
    height: 400px;
  }
  .arrecredihome1v_vtleft img{
    display: block;
    width: 400px;
    height: 400px;
  }
  .arrecredihome1v_vtright{
    width: 920px;
    height: 400px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
  .arrecredihome1v_vtr{
    width: 100%;
    height: auto;
    box-sizing: border-box;
    padding: 0 0 0 40px;
  }
  .arrecredihome1v_vtrtitle{
    width: 100%;
    height: 50px;
    font-weight: bold;
    font-size: 30px;
    color: #262A48;
    line-height: 30px;
    text-align: left;
    font-style: normal;
  }
  .arrecredihome1v_vtrtext{
    width: 540px;
    height: auto;
    font-weight: 500;
    font-size: 20px;
    color: #262A48;
    line-height: 30px;
    text-align: left;
    font-style: normal;
  }
  .arrecredihome1v_vdleft{
    width: 920px;
    height: 400px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }
  .arrecredihome1v_vdl{
    width: 100%;
    height: auto;
    box-sizing: border-box;
    padding: 0 40px 0 0;
  }
  .arrecredihome1v_vdltitle{
    width: 100%;
    height: 50px;
    font-weight: bold;
    font-size: 30px;
    color: #262A48;
    line-height: 30px;
    text-align: right;
    font-style: normal;
  }
  .arrecredihome1v_vdltext{
    width: 100%;
    height: auto;
    box-sizing: border-box;
    padding: 0 0 0 268px;
    font-weight: 500;
    font-size: 20px;
    color: #262A48;
    line-height: 30px;
    text-align: right;
    font-style: normal;
  }
  .arrecredihome1v_vdright{
    width: 400px;
    height: 400px;
  }
  .arrecredihome1v_vdright img{
    display: block;
    width: 400px;
    height: 400px;
  }
  .arrecredihome2v{
    max-width: 1320px;
    width: 100%;
    height: auto;
    margin: 0 auto;
    box-sizing: border-box;
    padding: 0 16px;
  }
  .arrecredihome2v_dv{
    width: 100%;
    height: 470px;
    display: flex;
    justify-content: space-between;
  }
  .arrecredihome2v_270{
    width: 270px;
    height: 470px;
    background: #cccccc;
    -webkit-transition: all cubic-bezier(0.15, 0.64, 0.43, 0.88) .6s;
    transition: all cubic-bezier(0.15, 0.64, 0.43, 0.88) .6s;
    cursor: pointer;
    position: relative;
  }
  .arrecredihome2v_740{
    width: 740px;
    height: 470px;
    background: #00CA88;
    -webkit-transition: all cubic-bezier(0.15, 0.64, 0.43, 0.88) .6s;
    transition: all cubic-bezier(0.15, 0.64, 0.43, 0.88) .6s;
    cursor: pointer;
    position: relative;
  }
  .arrecredihome2v_1{
    background: #00E2ED;
    border-radius: 40px;
    box-sizing: border-box;
    padding: 64px 0 0 34px;
  }
  .arrecredihome2v_2{
    background: #FFC25D;
    border-radius: 40px;
    box-sizing: border-box;
    padding: 64px 0 0 34px;
  }
  .arrecredihome2v_3{
    background: #37496B;
    border-radius: 40px;
    box-sizing: border-box;
    padding: 64px 0 0 34px;
  }
  .arrecredihome2v_title{
    width: 100%;
    height: auto;
    font-weight: bold;
    font-size: 28px;
    color: #262A48;
    line-height: 28px;
    text-align: left;
    font-style: normal;
    box-sizing: border-box;
    padding: 0 23px 0 0;
  }
  .arrecredihome2v_1 .arrecredihome2v_title{
    color: #262A48;
  }
  .arrecredihome2v_2 .arrecredihome2v_title{
    color: #262A48;
  }
  .arrecredihome2v_3 .arrecredihome2v_title{
    color: #FFFFFF;
  }

  @-webkit-keyframes van-fade-in {
    from {
      opacity: 0
    }

    to {
      opacity: 1
    }
  }

  @keyframes van-fade-in {
    from {
      opacity: 0
    }

    to {
      opacity: 1
    }
  }

  @-webkit-keyframes van-fade-out {
    from {
      opacity: 1
    }

    to {
      opacity: 0
    }
  }

  @keyframes van-fade-out {
    from {
      opacity: 1
    }

    to {
      opacity: 0
    }
  }

  .arrecredihome2v_270{
    overflow: hidden;
  }
  .arrecredihome2v_270 .arrecredihome2v_1_card{
    width: 194px;
    height: 262px;
    position: absolute;
    right: 10px;
    bottom: 0px;
    -webkit-transition: all cubic-bezier(0.15, 0.64, 0.43, 0.88) .6s;
    transition: all cubic-bezier(0.15, 0.64, 0.43, 0.88) .6s;
  }

  .arrecredihome2v_270 .arrecredihome2v_1_card:hover{
    transform: scale(1.2);
  }

  .arrecredihome2v_740 .arrecredihome2v_1_card{
    width: 270px;
    height: 348px;
    position: absolute;
    right: 45px;
    bottom: 0;
    -webkit-transition: all cubic-bezier(0.15, 0.64, 0.43, 0.88) .6s;
    transition: all cubic-bezier(0.15, 0.64, 0.43, 0.88) .6s;
  }

  .arrecredihome2v_270 .arrecredihome2v_2_card{
    width: 211px;
    height: 262px;
    position: absolute;
    right: 10px;
    bottom: 0px;
    -webkit-transition: all cubic-bezier(0.15, 0.64, 0.43, 0.88) .6s;
    transition: all cubic-bezier(0.15, 0.64, 0.43, 0.88) .6s;
  }

  .arrecredihome2v_270 .arrecredihome2v_2_card:hover{
    transform: scale(1.2);
  }

  .arrecredihome2v_740 .arrecredihome2v_2_card{
    width: 294px;
    height: 348px;
    position: absolute;
    right: 35px;
    bottom: 0;
    -webkit-transition: all cubic-bezier(0.15, 0.64, 0.43, 0.88) .6s;
    transition: all cubic-bezier(0.15, 0.64, 0.43, 0.88) .6s;
  }

  .arrecredihome2v_270 .arrecredihome2v_3_card{
    width: 194px;
    height: 262px;
    position: absolute;
    right: 10px;
    bottom: 0px;
    -webkit-transition: all cubic-bezier(0.15, 0.64, 0.43, 0.88) .6s;
    transition: all cubic-bezier(0.15, 0.64, 0.43, 0.88) .6s;
  }

  .arrecredihome2v_270 .arrecredihome2v_3_card:hover{
    transform: scale(1.2);
  }

  .arrecredihome2v_740 .arrecredihome2v_3_card{
    width: 270px;
    height: 348px;
    position: absolute;
    right: 46px;
    bottom: 0;
    -webkit-transition: all cubic-bezier(0.15, 0.64, 0.43, 0.88) .6s;
    transition: all cubic-bezier(0.15, 0.64, 0.43, 0.88) .6s;
  }
  .arrecredihome2v_270 .arrecredihome2v_1_bg{
    /*display: none;*/
    -webkit-animation: 1.3s van-fade-out both ease-in;
    animation: 1.3s van-fade-out both ease-in
  }
  .arrecredihome2v_740 .arrecredihome2v_1_bg{
    /*display: block;*/
    width: 416px;
    height: 348px;
    position: absolute;
    left: 0;
    bottom: 0;
    -webkit-animation: 1s van-fade-in both ease-out;
    animation: 1s van-fade-in both ease-out
  }
  .arrecredihome2v_1_bg img{
    display: block;
    width: 416px;
    height: 348px;
    -webkit-transition: all cubic-bezier(0.15, 0.64, 0.43, 0.88) .6s;
    transition: all cubic-bezier(0.15, 0.64, 0.43, 0.88) .6s;
  }
  .arrecredihome2v_270 .arrecredihome2v_2_bg{
    /*display: none;*/
    -webkit-animation: 1.3s van-fade-out both ease-in;
    animation: 1.3s van-fade-out both ease-in
  }
  .arrecredihome2v_740 .arrecredihome2v_2_bg{
    /*display: block;*/
    width: 416px;
    height: 348px;
    position: absolute;
    left: 0;
    bottom: 0;
    -webkit-animation: 1s van-fade-in both ease-out;
    animation: 1s van-fade-in both ease-out
  }
  .arrecredihome2v_2_bg img{
    display: block;
    width: 416px;
    height: 348px;
    -webkit-transition: all cubic-bezier(0.15, 0.64, 0.43, 0.88) .6s;
    transition: all cubic-bezier(0.15, 0.64, 0.43, 0.88) .6s;
  }
  .arrecredihome2v_270 .arrecredihome2v_3_bg{
    /*display: none;*/
    -webkit-animation: 1.3s van-fade-out both ease-in;
    animation: 1.3s van-fade-out both ease-in
  }
  .arrecredihome2v_740 .arrecredihome2v_3_bg{
   /* display: block;*/
    width: 416px;
    height: 348px;
    position: absolute;
    left: 0;
    bottom: 0;
    -webkit-animation: 1s van-fade-in both ease-out;
    animation: 1s van-fade-in both ease-out
  }
  .arrecredihome2v_3_bg img{
    display: block;
    width: 416px;
    height: 348px;
    -webkit-transition: all cubic-bezier(0.15, 0.64, 0.43, 0.88) .6s;
    transition: all cubic-bezier(0.15, 0.64, 0.43, 0.88) .6s;
  }

  .arrecredihome2v_270 .arrecredihome2v_1_text{
    display: none;
  }
  .arrecredihome2v_740 .arrecredihome2v_1_text{
    display: block;
    width: 416px;
    height: 348px;
    position: absolute;
    left: 0;
    bottom: 0;
    -webkit-transition: all cubic-bezier(0.15, 0.64, 0.43, 0.88) .6s;
    transition: all cubic-bezier(0.15, 0.64, 0.43, 0.88) .6s;
    box-sizing: border-box;
    padding: 0 48px 0 34px;
    font-weight: 500;
    font-size: 20px;
    color: #262A48;
    line-height: 24px;
    text-align: left;
    font-style: normal;
  }
  .arrecredihome2v_270 .arrecredihome2v_2_text{
    display: none;
  }
  .arrecredihome2v_740 .arrecredihome2v_2_text{
    display: block;
    width: 416px;
    height: 348px;
    position: absolute;
    left: 0;
    bottom: 0;
    -webkit-transition: all cubic-bezier(0.15, 0.64, 0.43, 0.88) .6s;
    transition: all cubic-bezier(0.15, 0.64, 0.43, 0.88) .6s;
    box-sizing: border-box;
    padding: 0 48px 0 34px;
    font-weight: 500;
    font-size: 20px;
    color: #262A48;
    line-height: 24px;
    text-align: left;
    font-style: normal;
  }
  .arrecredihome2v_270 .arrecredihome2v_3_text{
    display: none;
  }
  .arrecredihome2v_740 .arrecredihome2v_3_text{
    display: block;
    width: 416px;
    height: 348px;
    position: absolute;
    left: 0;
    bottom: 0;
    -webkit-transition: all cubic-bezier(0.15, 0.64, 0.43, 0.88) .6s;
    transition: all cubic-bezier(0.15, 0.64, 0.43, 0.88) .6s;
    box-sizing: border-box;
    padding: 0 48px 0 34px;
    font-weight: 500;
    font-size: 20px;
    color: #FFFFFF;
    line-height: 24px;
    text-align: left;
    font-style: normal;
  }
  .arrecredihome3v{
    max-width: 1320px;
    width: 100%;
    height: 1234px;
    margin: 0 auto;
    box-sizing: border-box;
    padding: 240px 16px 0 16px;
  }
  .arrecredihome3v_title{
    width: 100%;
    height: 200px;
  }
  .arrecredihome3v_title span{
    display: block;
    width: 100%;
    font-weight: bold;
    font-size: 48px;
    color: #262A48;
    line-height: 48px;
    text-align: left;
    font-style: normal;
    text-align: center;
  }
  .arrecredihome3v_title p{
    width: 100%;
    height: 80px;
    font-weight: 500;
    font-size: 20px;
    color: #262A48;
    line-height: 80px;
    text-align: center;
    font-style: normal;
  }
  .arrecredihome3v_dv{
    width: 100%;
    height: 554px;
    background: #C1F1F3;
    background: rgba(192, 241, 243, 0.2);
    border-radius: 40px;
    border: 1px solid rgba(18,161,192,0.5);
    display: flex;
    justify-content: space-between;
  }
  .arrecredihome3v_dv_left{
    width: 600px;
    height: 554px;
    position: relative;
  }
  .arrecredihome3v_dv_carousel{
    width: 600px;
    height: 554px;
    position: absolute;
    left: 0;
    top: 0;
    background: #C1EDF3;
    border-radius: 40px;
    border: 1px solid rgba(18,161,192,0.5);
    cursor: pointer;
  }
  .arrecredihome3v_dv_right{
    width: 720px;
    height: 554px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .arrecredihome3v_dv_carousel .el-carousel__indicators{
    bottom: 75px;
  }
  .arrecredihome3v_dv_carousel .el-carousel__button{
    width: 10px;
    height: 10px;
    -webkit-border-radius: 50%;
    -moz-border-radius: 50%;
    border-radius: 50%;
    background: #8BD8E3;
  }
  .arrecredihome3v_dv_carousel .is-active .el-carousel__button{
    background: #12A1C0;
  }
  .arrecredihome3v_dv_ldv{
    width: 100%;
    height: 42px;
    position: absolute;
    left: 0;
    bottom: 75px;
    z-index: 2;
    box-sizing: border-box;
    padding: 0 68px;
    display: flex;
    justify-content: space-between;
  }
  .arrecredihome3v_dv_ldvprev{
    width: 52px;
    height: 42px;
    cursor: pointer;
  }
  .arrecredihome3v_dv_ldvnext{
    width: 52px;
    height: 42px;
    cursor: pointer;
  }
  .arrecredihome3v_carousel{
    width: 100%;
    height: 437px;
    box-sizing: border-box;
    padding: 68px 0 0 68px;
  }
  .arrecredihome3v_carousel_no{
    font-family: Montserrat, Montserrat;
    font-weight: bold;
    font-size: 28px;
    color: #262A48;
    line-height: 28px;
    text-align: left;
    font-style: normal;
  }
  .arrecredihome3v_carousel_label{
    width: 100%;
    height: 95px;
    font-family: Montserrat, Montserrat;
    font-weight: bold;
    font-size: 28px;
    color: #262A48;
    line-height: 28px;
    text-align: left;
    font-style: normal;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    padding: 12px 0 0 0;
  }
  .arrecredihome3v_carousel_text span{
    display: block;
    width: 100%;
    font-family: Montserrat, Montserrat;
    font-weight: bold;
    font-size: 20px;
    color: #262A48;
    line-height: 30px;
    text-align: left;
    font-style: normal;
    padding: 0 0 12px 0;
  }
  .arrecredihome3v_carousel_text p{
    width: 80%;
    font-weight: 500;
    font-size: 20px;
    color: #262A48;
    line-height: 30px;
    text-align: left;
    font-style: normal;
  }
  .arrecredihome3v_dv_rmg{
    width: 243px;
    height: 451px;
  }
  .arrecredihome3v_dv_rmg img{
    display: block;
    width: 243px;
    height: 451px;
    -webkit-animation: 1s van-fade-in both ease-out;
    animation: 1s van-fade-in both ease-out
  }
  .arrecredihome4v{
    width: 94.74%;
    max-width: 1320px;
    height: auto;
    margin: 0 auto;
  }
  .arrecredihome4v img{
    display: block;
    width: 100%;
  }
  .arrecredihome5v{
    max-width: 1320px;
    width: 100%;
    height: 1050px;
    margin: 0 auto;
    box-sizing: border-box;
    padding: 240px 16px 0 16px;
  }
  .arrecredihome5v_title{
    width: 100%;
    height: 200px;
  }
  .arrecredihome5v_title span{
    display: block;
    width: 100%;
    font-weight: bold;
    font-size: 48px;
    color: #262A48;
    line-height: 48px;
    text-align: left;
    font-style: normal;
    text-align: center;
  }
  .arrecredihome5v_title p{
    width: 100%;
    height: 80px;
    font-weight: 500;
    font-size: 20px;
    color: #262A48;
    line-height: 80px;
    text-align: center;
    font-style: normal;
  }
  .arrecredihome5v_dv{
    max-width: 1260px;
    width: 100%;
    height: 446px;
    margin: 0 auto;
    background: rgba(193, 241, 243, 0.2);
    border-radius: 40px;
    border: 1px solid rgba(18,161,192,0.5);
    display: flex;
    justify-content: space-between;
    overflow: hidden;
  }

  /* ========= 移动端适配 ========= */
  @media (max-width: 1024px) {
    .libe_home_banner{
      height: auto;
    }
    .libe_home_banner_img{
      position: relative;
      width: 100%;
      left: 0;
      margin-left: 0;
    }
    .libe_home_banner_img img{
      width: 100%;
      height: auto;
    }
  }

  @media (max-width: 768px) {
    .arrecredi_btoptext_img{
      position: static;
      width: 100%;
      height: auto;
      margin-top: 16px;
    }
    .arrecredi_btoptext_img img{
      height: auto;
    }
    .arrecredi_bcenttext_desc{
      position: static;
      width: 100%;
      margin-top: 12px;
      font-size: 16px;
      line-height: 24px;
    }
    .google_link_wrap{
      position: static;
      width: 200px;
      height: auto;
      margin: 24px auto 0 auto;
    }
    .arrecredi_bdondv{
      padding-top: 24px;
    }
    .arrecredi_bdon_list{
      position: static;
      height: auto;
    }
    .arrecredi_bdon_view{
      position: static;
      height: auto;
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      gap: 12px;
    }
    .arrecredi_bdon_one,
    .arrecredi_bdon_two,
    .arrecredi_bdon_thr,
    .arrecredi_bdon_fur{
      position: static;
      width: 45%;
      height: auto;
    }
    .arrecredihome1v{
      padding-top: 120px;
    }
    .arrecredihome1v_title span{
      font-size: 28px;
    }
    .arrecredihome1v_view{
      height: auto;
      flex-direction: column;
      align-items: center;
    }
    .arrecredihome1v_vtleft,
    .arrecredihome1v_vdright{
      width: 70%;
      max-width: 320px;
      height: auto;
      margin-bottom: 16px;
    }
    .arrecredihome1v_vtleft img,
    .arrecredihome1v_vdright img{
      width: 100%;
      height: auto;
    }
    .arrecredihome1v_vtright,
    .arrecredihome1v_vdleft{
      width: 100%;
      height: auto;
      justify-content: center;
    }
    .arrecredihome1v_vtr{
      padding-left: 0;
      text-align: center;
    }
    .arrecredihome1v_vtrtitle,
    .arrecredihome1v_vdltitle{
      font-size: 22px;
      text-align: center;
    }
    .arrecredihome1v_vdltext,
    .arrecredihome1v_vtrtext{
      width: 100%;
      padding: 0;
      font-size: 16px;
      line-height: 24px;
      text-align: center;
    }

    .arrecredihome2v_dv{
      flex-direction: column;
      height: auto;
      gap: 16px;
    }
    .arrecredihome2v_270,
    .arrecredihome2v_740{
      width: 100%;
      height: 320px;
    }
    .arrecredihome2v_title{
      font-size: 20px;
    }
    .arrecredihome2v_1_text,
    .arrecredihome2v_2_text,
    .arrecredihome2v_3_text{
      width: auto;
      padding: 0 16px;
      font-size: 16px;
      line-height: 22px;
    }

    .arrecredihome3v{
      padding-top: 160px;
      height: auto;
    }
    .arrecredihome3v_title span{
      font-size: 28px;
    }
    .arrecredihome3v_title p{
      font-size: 16px;
      line-height: 24px;
      height: auto;
    }
    .arrecredihome3v_dv{
      flex-direction: column;
      height: auto;
    }
    .arrecredihome3v_dv_left,
    .arrecredihome3v_dv_carousel{
      width: 100%;
      border-radius: 24px 24px 0 0;
    }
    .arrecredihome3v_dv_right{
      width: 100%;
      padding: 24px 0;
      height: auto;
    }
    .arrecredihome3v_carousel{
      padding: 32px 16px 0 16px;
      height: auto;
    }
    .arrecredihome3v_carousel_no,
    .arrecredihome3v_carousel_label{
      font-size: 20px;
      line-height: 26px;
    }
    .arrecredihome3v_carousel_text p{
      width: 100%;
      font-size: 16px;
      line-height: 24px;
    }
    .arrecredihome3v_dv_ldv{
      padding: 0 24px;
    }

    .arrecredihome5v{
      padding-top: 120px;
      padding-bottom: 40px;
      height: auto;
    }
    .arrecredihome5v_title{
      margin-bottom: 32px;
    }
    .arrecredihome5v_title span{
      font-size: 26px;
      line-height: 32px;
    }
    .arrecredihome5v_title p{
      font-size: 15px;
      line-height: 22px;
      height: auto;
      margin-top: 12px;
    }
    .arrecredihome5v_dv{
      flex-direction: column;
      height: auto;
      padding: 0;
      border-radius: 16px;
    }
    .arrecredihome5v_dv_left{
      display: none;
    }
    .arrecredihome5v_dv_right{
      width: 100%;
      height: auto;
    }
    .arrecredihome5v_dv_rv{
      width: 100%;
      height: auto;
      min-height: auto;
      padding: 14px 16px;
      flex-wrap: wrap;
      gap: 8px;
    }
    .arrecredihome5v_dv_rv_text{
      width: calc(100% - 60px);
      flex: 1;
      font-size: 16px;
      line-height: 22px;
      word-wrap: break-word;
      overflow-wrap: break-word;
    }
    .arrecredihome5v_dv_rv_icon{
      width: 40px;
      height: 40px;
      flex-shrink: 0;
    }
    .arrecredihome5v_dv_rv_icon img{
      width: 40px;
      height: 40px;
    }
    .arrecredihome5v_dv_rv_hover{
      height: auto;
      min-height: auto;
      margin-bottom: 0;
    }
    .arrecredihome5v_dv_rv_hover:not(:last-child) .arrecredihome5v_dv_rv{
      border-bottom: 1px solid #DFEBED;
    }
    .arrecredihome5v_ddmg{
      width: 200px;
      height: auto;
      position: static;
      margin: 32px auto 0 auto;
    }
    .arrecredihome5v_ddmg img{
      width: 100%;
      height: auto;
    }
  }
  .arrecredihome5v_dv_left{
    width: 468px;
    height: 446px;
    position: relative;
  }
  .arrecredihome5v_dv_right{
    width: 792px;
    height: 446px;
  }
  .arrecredihome5v_dv_rv{
    width: 732px;
    height: 148px;
    border-bottom: 1px solid #DFEBED;
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
    box-sizing: border-box;
    padding: 0 0 0 10px;
  }
  .arrecredihome5v_dv_rv_text{
    width: 680px;
    height: 28px;
    font-weight: 500;
    font-size: 28px;
    color: #262A48;
    line-height: 28px;
    text-align: left;
    font-style: normal;
  }
  .arrecredihome5v_dv_rv_icon{
    width: 52px;
    height: 42px;
  }
  .arrecredihome5v_dv_rv_icon img{
    display: block;
    width: 52px;
    height: 42px;
  }
  .arrecredihome5v_dv_rv_hover{
    width: 100%;
    height: 148px;
  }
  .arrecredihome5v_dv_rv_hover:hover{
    background: #e9e9fa;
  }
  .arrecredihome5v_dd{
    width: 100%;
    height: 1px;
    position: relative;
  }
  .arrecredihome5v_ddmg{
    width: 300px;
    height: 344px;
    position: absolute;
    left: 64px;
    top: -317px;
  }
  .arrecredihome5v_ddmg img{
    display: block;
    width: 300px;
    height: 344px;
  }
</style>
